const apiUrl = process.env.REACT_APP_API_URL;

export const signin = async(obj) => {
    const url =  `${apiUrl}/api/auth/signin`;       
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}

export const resetPassword = async(obj) => {
    const url =  `${apiUrl}/api/auth/resetPassword`;       
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}

export const checkIfUserHasAPwdRequest = async(token) => {
    const url =  `${apiUrl}/api/auth/checkIfUserHasAPwdRequest/${token}`;       
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}

export const updatePassword = async(obj) => {
    const url =  `${apiUrl}/api/auth/updatePassword`;       
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(obj)
    };
    try {
       const response = await fetch(url, requestOptions);
       return await response.json(); 
    } catch (error) {
        return { result: false }
    }
}

